import * as React from "react";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  redirect,
} from "react-router-dom";

import { getMe } from "../api/auth";
import { store } from "../store";
import { setSlug } from "../store/workspaceSlice";
import AudiencePage from "./audience-page";
import AudiencesPage from "./audiences-page";
import ConversionEventsPage from "./conversion-events-page";
import DashboardPage from "./dashboard-page";
import JoinWorkspacePage from "./join-workspace-page";
import LoginPage from "./login-page";
import RetargetingPage from "./retargeting-page";
import Root from "./root";
import GeneralSettingsPage from "./settings/general-page";
import IntegrationsPage from "./settings/integrations-page";
import PixelPage from "./settings/pixel-page";
import SettingsRoot from "./settings/root";
import SignUpPage from "./signup-page";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        index
        loader={async () => {
          try {
            const { workspaces } = await getMe();
            return redirect(`/workspaces/${workspaces[0].slug}`);
          } catch {
            return redirect("/login");
          }
        }}
      />
      <Route
        path="workspaces/:workspace"
        element={<Root />}
        loader={async ({ params }) => {
          const { workspace } = params;
          store.dispatch(setSlug(workspace));
          return null;
        }}
      >
        <Route path="" element={<DashboardPage />} />
        <Route path="audiences">
          <Route index element={<AudiencesPage />} />
          <Route path=":id" element={<AudiencePage />} />
        </Route>
        <Route path="retargeting">
          <Route index element={<RetargetingPage />} />
        </Route>
        <Route path="conversion-events">
          <Route index element={<ConversionEventsPage />} />
        </Route>
        <Route path="settings" element={<SettingsRoot />}>
          <Route path="" element={<GeneralSettingsPage />} />
          <Route path="integrations" element={<IntegrationsPage />} />
          <Route path="pixel" element={<PixelPage />} />
        </Route>
      </Route>
      <Route path="join-workspace/:id/:token" element={<JoinWorkspacePage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="signup" element={<SignUpPage />} />
    </>,
  ),
);
